module.exports = __webpack_public_path__ + "static/media/icon-2w.47b03606.svg";